
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router';

//import service
import pservice from '@/core/services/PublicService';

export default defineComponent({
    name: "public-sport-teams",
    setup() {
        const loading = ref(false)
        const route = useRoute();
        const { idevent, idsport } = route.params
        const listClubs = ref<any>([])

        const getClubs = async () => {
            loading.value = true
            await pservice.getClubs({
                evento: idevent,
                sport: idsport
            })
                .then((res) => {
                    listClubs.value = res.data
                    loading.value = false
                }).catch(({ response }) => { loading.value = false })

        }

        onMounted(() => {
            getClubs()
        })

        return {
            loading,
            listClubs,
            getClubs

        }

    },
})
